import { ensureAll } from '../store/busesSlice';
import { useSelector, useDispatch } from 'react-redux';
import { useEffect } from 'react';



function BusSelectStateful({ value, setValue, ...props }) {
    const dispatch = useDispatch();
    const _buses = useSelector((state) => state.buses.knownBuses);
    const buses = Object.values(_buses).sort((a, b) => a.bus_name.localeCompare(b.bus_name));

    useEffect(() => {
        dispatch(ensureAll());
    }, []);

    useEffect(() => {
        if (!buses.length) return;
        if(value) return;
        setValue(buses[0].bus_id);
    }, [buses]);

    return (
        <select value={value} onChange={(e) => setValue(e.target.value)} {...props} >
            { buses.map(bus => (
                <option value={bus.bus_id}>{bus.bus_name}</option>
            )) }
        </select>
    );
};

export default BusSelectStateful;